export const ContactIDtoString: Record<string, string> = {
    "TestContact1": "IT Admin",
    "TestContact2": "Another Contact",
    "TestContact3": "A Person",
    "TestContact4": "Xx_aPerson_xX",
    "TestContact5": "uwu a purrson",
    "TestContact6": "Autta Idias",
};